import React, { FC } from "react";
import { LegalLayout } from "src/features/ofac/components/LegalLayout";
import { TermsOfUse } from "src/features/ofac/imports/ui";

export const TermsOfUsePage: FC = () => (
  <LegalLayout>
    <TermsOfUse />
  </LegalLayout>
);
